<template>
  <section class="integrations">
    <yn-list
      name="integratioons"
      :data="integrations"
      :total="integrations.length"
      :metadata="{
        source: {
          label: 'Source',
          width: '200px'
        },
        token: {
          label: 'Token',
          width: 'minmax(0, 1fr)'
        }
      }"
      :actions="[{ name: 'delete', label: '&times;', tooltip: 'Delete this integration' }]"
      @delete="remove"
    >
    </yn-list>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import List from './../common/List';

export default {
  components: {
    'yn-list': List
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState({
      integrations: s => s.topics.item.integrations || []
    })
  },
  methods: {
    async remove({ id: integrationId, name }) {
      const lock = this.$lock();

      try {
        await this.$store.dispatch('topics/removeIntegration', {
          id: this.id,
          integrationId
        });
        this.$toast.success({
          title: 'Update completed',
          message: `Integration '${name}' was removed from this topic.`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Update failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>
